export const initialStoricoFilterData = {
  data: {
    numeriSpeciali: [],
    tipoRichiesta: [],
  },
  loading: false,
};
